/**
 * The hero background: a layered radial-gradient mesh in the brand blues.
 *
 * Deliberately CSS-only. An earlier version animated four large blurred divs
 * with GSAP, which was a significant source of jank: `filter: blur()` on a big
 * moving element forces the compositor to re-rasterize it every frame.
 *
 * These are background gradients on a small number of layers instead, animated
 * with transforms only, so the whole thing composites on the GPU and the main
 * thread stays free for scrolling.
 */
export function GradientMesh({ className = '' }: { className?: string }) {
  return (
    <div className={`absolute inset-0 overflow-hidden bg-ink ${className}`} aria-hidden="true">
      {/* Static base wash — no animation, no blur, no cost. */}
      <div
        className="absolute inset-0"
        style={{
          background:
            'radial-gradient(120% 90% at 12% 8%, rgb(30 104 194 / 0.55), transparent 62%),' +
            'radial-gradient(100% 80% at 88% 22%, rgb(79 151 234 / 0.30), transparent 60%),' +
            'radial-gradient(130% 100% at 30% 108%, rgb(0 79 182 / 0.42), transparent 66%)',
        }}
      />

      {/* Two slow drifting layers. Transform-only, so they stay on the GPU. */}
      <div
        className="absolute -inset-1/4 falcon-drift-a"
        style={{
          background: 'radial-gradient(closest-side, rgb(79 151 234 / 0.22), transparent 70%)',
          willChange: 'transform',
        }}
      />
      <div
        className="absolute -inset-1/4 falcon-drift-b"
        style={{
          background: 'radial-gradient(closest-side, rgb(30 104 194 / 0.20), transparent 72%)',
          willChange: 'transform',
        }}
      />

      {/* Vignette: keeps headline contrast high over the brightest areas. */}
      <div
        className="absolute inset-0"
        style={{
          background:
            'linear-gradient(to bottom, rgb(12 35 64 / 0.45) 0%, rgb(12 35 64 / 0.25) 45%, rgb(10 30 55 / 0.80) 100%)',
        }}
      />
    </div>
  );
}
